module.exports = __webpack_public_path__ + "img/vertical_7_3_5012.ca308598.png";